import type { Dispatch, SetStateAction } from 'react';
import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { ActiveLink } from '~/components/commons/ActiveLink/ActiveLink';
import { isUserAdmin } from '~/components/Profile/utils';
import appConst from '~/const/appConst';

export const SettingsNavigation = (
  { setDisplayMain }:
  { setDisplayMain: Dispatch<SetStateAction<boolean>> }) => {
  const t = useTranslations('SETTINGS');

  const { user } = useAuthenticatedContext();
  const { settings, notifications, personal_data } = appConst.staticRoutes;
  const isAdmin = user && isUserAdmin(user);

  return (
    <aside className="profile__aside">
      <nav className="profile__nav">
        <ul className="vp-link-list vp-link-list--small">
          {isAdmin && (
            <li className="vp-link-list__item">
              <ActiveLink
                data-testid="administrator-data-link"
                href={settings}
                className="vp-link-list__item-link"
                onClick={() => setDisplayMain(true)}
              >
                <span className="profile__link-list__item">
                  <VpIcon name="lock" size={24} />
                  {' '}
                  {t('ADMINISTRATOR_DATA.TITLE')}
                </span>
                <VpIcon name="chevron-right" size={20} />
              </ActiveLink>
            </li>
          )}
          <li className="vp-link-list__item">
            <ActiveLink
              href={isAdmin ? notifications : settings}
              className="vp-link-list__item-link"
              {...(!isAdmin && { onClick: () => setDisplayMain(true) })}
            >
              {t('NOTIFICATION.TITLE')}
              <VpIcon name="chevron-right" size={20} />
            </ActiveLink>
          </li>
          <li className="vp-link-list__item">
            <ActiveLink
              href={personal_data}
              className="vp-link-list__item-link"
            >
              {t('PERSONAL_DATA.TITLE')}
              <VpIcon name="chevron-right" size={20} />
            </ActiveLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};
